(() => {
  if (window.yahavReviewAutoplay) return;
  window.yahavReviewAutoplay = true;
  const init = (root = document) => {
    root.querySelectorAll('[data-review-autoplay="true"]').forEach(async (carousel) => {
      await customElements.whenDefined('yahav-carousel');
      if (carousel.reviewCleanup || !carousel.isConnected) return;
      const button = carousel.querySelector('[data-review-pause]');
      if (!button) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches || Boolean(window.Shopify?.designMode);
      let visible = false;
      let hovering = false;
      const sync = () => {
        const label = paused ? 'Play auto-scroll' : 'Pause auto-scroll';
        button.setAttribute('aria-label', label);
        button.title = label;
        button.setAttribute('aria-pressed', String(paused));
      };
      button.hidden = false;
      sync();
      button.addEventListener('click', () => { paused = !paused; sync(); }, options);
      carousel.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') hovering = true; }, options);
      carousel.addEventListener('pointerleave', () => { hovering = false; }, options);
      const stop = (event) => {
        if (event.target.closest('[data-review-pause]')) return;
        paused = true;
        sync();
      };
      carousel.addEventListener('pointerdown', stop, options);
      carousel.addEventListener('keydown', stop, options);
      motion.addEventListener('change', () => { if (motion.matches) { paused = true; sync(); } }, options);
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: .5 });
      observer.observe(carousel);
      const timer = setInterval(() => {
        if (paused || hovering || !visible || document.hidden || (carousel.contains(document.activeElement) && document.activeElement !== button) || !(carousel.positions?.length > 1)) return;
        carousel.goTo(carousel.current >= carousel.positions.length - 1 ? 0 : carousel.current + 1);
      }, 6500);
      carousel.reviewCleanup = () => { clearInterval(timer); observer.disconnect(); controller.abort(); delete carousel.reviewCleanup; };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-review-autoplay]').forEach((carousel) => carousel.reviewCleanup?.()));
})();
